function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Notification } from '@signicat/designi/components/messages';
import { notificationSelector } from "../store/selectors/feed";
import { translationMissingSelector } from "../store/selectors/module";
import { setTranslationMissing } from "../store/actions/module";
import { t } from "../helpers/i18n";
var getBy = function getBy(event) {
  if (event.type === 'signed' && !event.name) {
    return t('all');
  } else if (!event.name) {
    return null;
  }
  return event.name;
};
var Notifications = function Notifications(props) {
  var translationMissingNotificationSID = -1;
  var dispatch = useDispatch();
  var notification = useSelector(notificationSelector);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    notificationToDisplay = _useState2[0],
    setNotificationToDisplay = _useState2[1];
  useEffect(function () {
    if (notification != null) {
      var by = getBy(notification);
      setNotificationToDisplay(_objectSpread(_objectSpread({}, notification), {}, {
        // TODO: Sort out how to present partially_signed signed events
        text: t('order_status_changed_notification', {
          name: notification.title || t('untitled'),
          status: t(notification.type === 'partially_signed' ? 'signed' : notification.type),
          by: "".concat(by ? t('order_status_changed_notification_by', {
            by: by
          }) : '')
        })
      }));
    }
  }, [notification]);
  var translationMissing = useSelector(translationMissingSelector);
  useEffect(function () {
    if (translationMissing.showNotification) {
      setNotificationToDisplay(_objectSpread(_objectSpread({}, notificationToDisplay), {}, {
        signOrderId: translationMissingNotificationSID,
        text: t('missing_translation_notification')
      }));
    }
  }, [translationMissing]);
  var handleNotificationDismiss = function handleNotificationDismiss(notification) {
    return function () {
      if (notification.sid === translationMissingNotificationSID) {
        dispatch(setTranslationMissing({
          showNotification: false,
          url: window.location.href
        }));
      }
      setNotificationToDisplay(null);
    };
  };
  return notificationToDisplay != null ? /*#__PURE__*/React.createElement(Notification, {
    key: notificationToDisplay.signOrderId,
    message: notificationToDisplay.text,
    onDismiss: handleNotificationDismiss(notificationToDisplay)
  }) : null;
};
export default Notifications;